// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bcdf64bf","455":"1404a61a","977":"d75a263f"}[chunkId] + ".chunk.js";
};